export default "__VITE_ASSET__DvXYkGzK__"